<template>
  <div :class="{main: true, lockOverflow: share.active}">
    <ShareWrapper v-if="share.active" :title="share.title" :link="share.link" @close="onShareClose"/>
    <SettingsWrapper v-if="settings.active" :dialogId="settings.dialogId" @close="onSettingsClose"/>

    <Nav>
      <template v-slot:logo-box>
        <Logo/>
      </template>
      <template v-slot:options-box>
        <DialoguesButton @closeSearchInput="onCloseSearchInput" @closeSearch="onCloseSearch" :searchInputState="getSearchInputState" @reload="loadData" class="v-step-0"/>
        <AddButton class="v-step-1"/>
        <Search ref="search" @openSearchInput="onOpenSearchInput" @searchDialog="onSearchDialog" @closeSearchInput="onCloseSearchInput" @closeSearch="onCloseSearch" :searchInputState="getSearchInputState" class="v-step-2"/>
      </template>
      <template v-slot:account-box>
        <AccountButton class="v-step-3"/>
      </template>
    </Nav>

    <v-tour name="myTour" :steps="steps" :callbacks="myCallbacks"></v-tour>

    <button class="tutorial-button v-step-4" v-if="windowSize >= 1025" title="Show Frogero Tour" @click="showTour">
      <font-awesome-icon :icon="['fas', 'torii-gate']" class="icon" />
    </button>

    <div class="body">
      <div class="content">
        <MobileSearchBox/>
        <SearchResults @remove="onDelete" @share="onShareOpen" @reload="onReload"/>
        <InfoBox :refresh="refreshInfoBox"/>

        <NoDialogs v-if="!loading && exercises.length == 0"/>

        <div class="this-week-box" v-if="!loading && thisWeekDialogs.length != 0 && !getShowResultBox">
          <div class="label">This Week</div>
          <div class="card" v-for="dialog in thisWeekDialogs" :key="dialog.shortId">
            <DialogCard v-if="dialog.type=='exercise'" :shortId="dialog.shortId" :id="dialog._id" @remove="onDelete" @share="onShareOpen" @reload="onReload" @loaded="dialogLoaded" @refresh="onRefresh" @openSettings="onSettingsOpen"/>
            <PinCard v-if="dialog.type=='pin'" :shortId="dialog.shortId" :id="dialog._id" @remove="onDelete" @share="onShareOpen" @reload="onReload" @loaded="dialogLoaded" @refresh="onRefresh"/>
          </div>
        </div>
        <div class="this-month-box" v-if="!loading && thisMonthDialogs.length != 0 && !getShowResultBox">
          <div class="label">This Month</div>
          <div class="card" v-for="dialog in thisMonthDialogs" :key="dialog.shortId">
            <DialogCard v-if="dialog.type=='exercise'" :shortId="dialog.shortId" :id="dialog._id" @remove="onDelete" @share="onShareOpen" @reload="onReload" @loaded="dialogLoaded" @refresh="onRefresh" @openSettings="onSettingsOpen"/>
            <PinCard v-if="dialog.type=='pin'" :shortId="dialog.shortId" :id="dialog._id" @remove="onDelete" @share="onShareOpen" @reload="onReload" @loaded="dialogLoaded" @refresh="onRefresh"/>
          </div>
          <!-- <DialogCard v-for="dialog in thisMonthDialogs" :key="dialog.shortId" :shortId="dialog.shortId" :id="dialog._id" @remove="onDelete" @share="onShareOpen" @reload="onReload" @loaded="dialogLoaded" @refresh="onRefresh"/> -->
        </div>
        <div class="older-box" v-if="!loading && olderDialogs.length != 0 && !getShowResultBox">
          <div class="label">Older</div>
          <div class="card" v-for="dialog in olderDialogs" :key="dialog.shortId">
            <DialogCard v-if="dialog.type=='exercise'" :shortId="dialog.shortId" :id="dialog._id" @remove="onDelete" @share="onShareOpen" @reload="onReload" @loaded="dialogLoaded" @refresh="onRefresh" @openSettings="onSettingsOpen"/>
            <PinCard v-if="dialog.type=='pin'" :shortId="dialog.shortId" :id="dialog._id" @remove="onDelete" @share="onShareOpen" @reload="onReload" @loaded="dialogLoaded" @refresh="onRefresh"/>
          </div>
          <!-- <DialogCard v-for="dialog in olderDialogs" :key="dialog.shortId" :shortId="dialog.shortId" :id="dialog._id" @remove="onDelete" @share="onShareOpen" @reload="onReload" @loaded="dialogLoaded" @refresh="onRefresh"/> -->
        </div>
        <div class="loading-bar" v-if="loading">
          <Loader/>
        </div>
      </div>
    </div>

    <footer>
      <div class="tutorial-row v-step-4" @click="showTour" v-if="windowSize < 1025">
        <font-awesome-icon :icon="['fas', 'torii-gate']" class="icon" />
        Show Frogero Tour
      </div>
    </footer>

  </div>
</template>

<script>
import axios from 'axios'
import alert from '@/lib/alert'
import { mapActions, mapGetters } from 'vuex'
import DialogCard from '@/components/Main/DialogCard'
import PinCard from '@/components/Main/PinCard'
import ShareWrapper from '@/components/Main/ShareWrapper'
import SettingsWrapper from '@/components/Main/SettingsWrapper'
import timer from '@/lib/timer'
import InfoBox from '@/components/Main/InfoBox'
import SearchResults from '@/components/Main/SearchResults'
import MobileSearchBox from '@/components/Main/MobileSearchBox'
import NoDialogs from '@/components/Main/NoDialogs'
import Loader from '@/components/Loader'
//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import DialoguesButton from '@/components/Nav/DialoguesButton'
import AccountButton from '@/components/Nav/AccountButton'
import AddButton from '@/components/Nav/AddButton'
import Search from '@/components/Nav/Search'

export default {
  name: 'Main',
  data() {
    return {
      exercises: [],
      loading: true,
      share: {
        title: '',
        link: '',
        active: false,
      },
      settings: {
        active: false,
      },
      dialogLoadCounter: 0,
      countRecordings: 0,
      refreshInfoBox: 0,
      steps: [
        {
          target: '.v-step-0',
          header: {
            title: 'Frogero Tour',
          },
          content: `Here you can <b>load</b> your Dialogues`
        },
        {
          target: '.v-step-1',
          header: {
            title: 'Frogero Tour',
          },
          content: `Click here to <b>add</b> new Dialogue`,
        },
        {
          target: '.v-step-2',
          header: {
            title: 'Frogero Tour',
          },
          content: `Use <b>search</b> to find others Dialogues`
        },
        {
          target: '.v-step-3',
          header: {
            title: 'Frogero Tour',
          },
          content: `Here you can find <b>Account options</b> or <b>Tutorials</b>`
        },
        {
          target: '.v-step-4',
          header: {
            title: 'Frogero Tour',
          },
          content: `Click here to show tour at any time!`,
          params: {
            highlight: true
          }
        },
      ],
      myCallbacks: {
        onSkip: this.skipTour,
        onFinish: this.finishTour,
      }
    }
  },
  components: {
    DialogCard,
    PinCard,
    ShareWrapper,
    InfoBox,
    SearchResults,
    MobileSearchBox,
    SettingsWrapper,
    NoDialogs,
    Loader,
    //Nav
    Nav,
    Logo,
    DialoguesButton,
    AccountButton,
    AddButton,
    Search
  },
  methods: {
    ...mapActions('player', ['playerStop']),
    ...mapActions('main', ['searchDialog', 'closeSearch', 'openSearchInput', 'closeSearchInput']),
    loadData() {
      this.loading = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadExercises`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
      }).then(result => {
        this.exercises = result.data.exercises;
        this.loading = false;
        if(this.exercises.length == 0) {
          this.noDialogs();
          if(localStorage.getItem('startTour') != 'true') {
            this.showTour();
          }
        }
      }).catch(err => {
        alert.showError(err);
      })
    },
    onDelete(shortId) {
      this.refreshInfoBox += 1;
      let index = this.exercises.findIndex(dialog => {
        return dialog.shortId == shortId;
      })
      this.exercises.splice(index, 1);
    },
    onShareClose() {
      this.share.title = '';
      this.share.link = '';
      this.share.active = false;
    },
    onSettingsClose() {
      this.settings.active = false;
    },
    onShareOpen(payload) {
      this.share.title = payload.title;
      this.share.link = payload.link;
      this.share.active = true;
    },
    onSettingsOpen(dialogId) {
      this.settings.active = true;
      this.settings.dialogId = dialogId;
    },
    onReload() {
      this.refreshInfoBox += 1;
      this.loading = true;
      this.loadData();
    },
    onRefresh() {
      this.refreshInfoBox += 1;
    },
    dialogLoaded(recordings) {
      this.countRecordings += recordings;
      this.dialogLoadCounter += 1;
      if(this.dialogLoadCounter == this.exercises.length) {
        timer.stop().then(time => {
          this.sendLoadData(time);
        })
      }
    },
    noDialogs() {
      timer.stop().then(time => {
        this.sendLoadData(time);
      })
    },
    sendLoadData(time) {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}saveLog`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          type: 'loadMain',
          time
        }
      }).then(() => {
        
      }).catch(err => {
        console.log(err);
      })
    },
    onOpenSearchInput() {
      this.openSearchInput();
    },
    onSearchDialog(query) {
      this.searchDialog(query);
    },
    onCloseSearchInput() {
      this.closeSearchInput();
    },
    onCloseSearch() {
      this.closeSearch();
    },
    showTour() {
      this.$tours['myTour'].start();
    },
    skipTour() {
      localStorage.setItem("startTour", true);
    },
    finishTour() {
      localStorage.setItem("startTour", true);
    }
  },
  computed: {
    ...mapGetters('main', ['getShowResultBox', 'getSearchInputState']),
    thisWeekDialogs() {
      let valid = [];
      const oneDay = 24 * 60 * 60 * 1000;

      let currentDate = new Date();
      let currentDay = currentDate.getDay();
      if(currentDay == 0) { currentDay = 7 }
      let currentMonth = currentDate.getMonth() + 1;
      let currentYear = currentDate.getFullYear();

      this.exercises.forEach(dialog => {
        let dialogDate = new Date(dialog.updated);
        let dialogDay = dialogDate.getDay();
        if(dialogDay == 0) { dialogDay = 7 }
        let dialogMonth = dialogDate.getMonth() +1;
        let dialogYear = dialogDate.getFullYear();

        let dayDiff = Math.round(Math.abs((dialogDate - currentDate) / oneDay));
        if(dayDiff < 8 && currentYear == dialogYear && currentMonth == dialogMonth && dialogDay <= currentDay) {
          valid.push(dialog);
        }
      });

      return valid.sort((a, b) => {
        return a.updated - b.updated;
      }).reverse();
    },
    thisMonthDialogs() {
      let valid = [];
      const oneDay = 24 * 60 * 60 * 1000;

      let currentDate = new Date();
      let currentDay = currentDate.getDay();
      if(currentDay == 0) { currentDay = 7 }
      let currentMonth = currentDate.getMonth() + 1;
      let currentYear = currentDate.getFullYear();

      this.exercises.forEach(dialog => {
        let dialogDate = new Date(dialog.updated);
        let dialogDay = dialogDate.getDay();
        if(dialogDay == 0) { dialogDay = 7 }
        let dialogMonth = dialogDate.getMonth() +1;
        let dialogYear = dialogDate.getFullYear();

        let dayDiff = Math.round(Math.abs((dialogDate - currentDate) / oneDay));
        if(currentYear == dialogYear && currentMonth == dialogMonth) {
          if(dayDiff > 7 || (dayDiff <= 7 && dialogDay > currentDay)) {
            valid.push(dialog);
          }
        }
      });

      return valid.sort((a, b) => {
        return a.updated - b.updated;
      }).reverse();
    },
    olderDialogs() {
      let valid = [];

      let currentDate = new Date();
      let currentMonth = currentDate.getMonth() + 1;
      let currentYear = currentDate.getFullYear();

      this.exercises.forEach(dialog => {
        let dialogDate = new Date(dialog.updated);
        let dialogMonth = dialogDate.getMonth() +1;
        let dialogYear = dialogDate.getFullYear();

        if((currentYear > dialogYear) || (currentYear == dialogYear && currentMonth > dialogMonth)) {
          valid.push(dialog);
        }
      });

      return valid.sort((a, b) => {
        return a.updated - b.updated;
      }).reverse();
    },
    windowSize() {
      return window.innerWidth;
    }
  },
  mounted() {
    timer.start();
    this.playerStop();
    this.loadData();
    if(!window.speechSynthesis) {
      alert.showWarning('Browser not supporting Text To Speech. Try opening the page in Google Chrome.');
    }
    if(this.$route.query.search != undefined) {
      this.openSearchInput();
      this.$refs.search.query = this.$route.query.search;
      this.searchDialog(this.$route.query.search);
    } else {
      this.closeSearch();
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: whitesmoke;
  overflow-x: hidden;
}

.lockOverflow {
  overflow: hidden;
}

.body {
  width: 100%;
  flex: auto;
  display: flex;
  justify-content: center;
}

.content {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  padding-top: 3rem;

  @media (max-width: 900px) {
    width: 90vw;
    padding-top: 2rem;
  }
}

.this-week-box {
  width: 55rem;
  height: auto;
  display: flex;
  flex-direction: column;
  @media (max-width: 900px) {
    width: 90vw;
  }

  .label {
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #25262921;
    color: #2526295b;
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }

  .no-dialogs {
    width: 100%;
    height: 3rem;
    margin-bottom: 3rem;
    font-size: 1rem;
    color: #2526295b;
  }
}

.this-month-box {
  width: 55rem;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  @media (max-width: 900px) {
    width: 90vw;
  }

  .label {
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #25262921;
    color: #2526295b;
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }

  .no-dialogs {
    width: 100%;
    height: 3rem;
    margin-bottom: 3rem;
    font-size: 1rem;
    color: #2526295b;
  }
}

.older-box {
  width: 55rem;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  @media (max-width: 900px) {
    width: 90vw;
  }

  .label {
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #25262921;
    color: #2526295b;
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }

  .no-dialogs {
    width: 100%;
    height: 3rem;
    margin-bottom: 3rem;
    font-size: 1rem;
    color: #2526295b;
  }
}

.loading-bar {
  width: 100%;
  height: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
}

.tutorial-button {
  border: none;
  outline: none;
  font-size: 1rem;
  width: 2.5rem;
  height: 2.5rem;
  background-color: #11b6a5;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  position: fixed;
  z-index: 100;
  bottom: 2rem;
  right: 2rem;
  transition: all 0.2s;

  @media (max-width: 1100px) {
    right: 1rem;
  }
  @media (max-width: 1025px) {
    display: none;
  }

  &:hover {
    cursor: pointer;
    background-color: #10a091;
  }
}

footer {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;

  .tutorial-row {
    user-select: none;
    width: 100%;
    height: 3rem;
    display: none;
    margin-bottom: 1rem;
    @media (max-width: 1025px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    color: darkgray;
    cursor: pointer;

    .icon {
      margin-right: 0.5rem;
      color: #11b6a5;
    }
  }
}
</style>